import styled from "styled-components";

const Header = styled.h2`
  font-size: 25px;
  text-transform: lowercase;
  font-weight: 800;
  margin-bottom: 10px;
  margin-top: 10px;

  @media (max-width: 991.98px) {
    font-size: 22px;
  }
  @media (max-width: 767px) {
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;
export default Header;
